import React, { useRef, useState } from "react";
import { db, storage, auth } from "../FirebaseConfig";
import { addDoc, collection } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { createUserWithEmailAndPassword } from "firebase/auth";
import Footer from "./Footer";
import Header from "./Header";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { uploadFileToCloudinary } from "../utils/cloudinary";

const UserForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    expertise: "",
    region: "",
    about: "",
    portfolio: "",
    socialLinks: {
      linkedin: "",
      fiverr: "",
      // twitter: "",
      facebook: "",
      upwork: "",
    },
    contact: {
      phone: "",
      email: "",
    },
    picture: null,
    skills: [],
    password: "", // Added password field for authentication
  });

  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customSkill, setCustomSkill] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownProfessionOpen, setIsDropdownProfessionOpen] =
    useState(false);
  const [errors, setErrors] = useState({
    phone: "",
    email: "",
    linkedin: "",
    fiverr: "",
    facebook: "",
    upwork: "",
    portfolio: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const dropdownRef = useRef(null);

  const getCountryCodeFromRegion = (region) => {
    const countryMap = {
      "Afghanistan 🇦🇫": "AF",
      "Albania 🇦🇱": "AL",
      "Algeria 🇩🇿": "DZ",
      "Andorra 🇦🇩": "AD",
      "Angola 🇦🇴": "AO",
      "Antigua and Barbuda 🇦🇬": "AG",
      "Argentina 🇦🇷": "AR",
      "Armenia 🇦🇲": "AM",
      "Australia 🇦🇺": "AU",
      "Austria 🇦🇹": "AT",
      "Azerbaijan 🇦🇿": "AZ",
      "Bahamas 🇧🇸": "BS",
      "Bahrain 🇧🇭": "BH",
      "Bangladesh 🇧🇩": "BD",
      "Barbados 🇧🇧": "BB",
      "Belarus 🇧🇾": "BY",
      "Belgium 🇧🇪": "BE",
      "Belize 🇧🇿": "BZ",
      "Benin 🇧🇯": "BJ",
      "Bhutan 🇧🇹": "BT",
      "Bolivia 🇧🇴": "BO",
      "Bosnia and Herzegovina 🇧🇦": "BA",
      "Botswana 🇧🇼": "BW",
      "Brazil 🇧🇷": "BR",
      "Brunei 🇧🇳": "BN",
      "Bulgaria 🇧🇬": "BG",
      "Burkina Faso 🇧🇫": "BF",
      "Burundi 🇧🇮": "BI",
      "Cabo Verde 🇨🇻": "CV",
      "Cambodia 🇰🇭": "KH",
      "Cameroon 🇨🇲": "CM",
      "Canada 🇨🇦": "CA",
      "Central African Republic 🇨🇫": "CF",
      "Chad 🇹🇩": "TD",
      "Chile 🇨🇱": "CL",
      "China 🇨🇳": "CN",
      "Colombia 🇨🇴": "CO",
      "Comoros 🇰🇲": "KM",
      "Congo, Democratic Republic of the 🇨🇩": "CD",
      "Congo, Republic of the 🇨🇬": "CG",
      "Costa Rica 🇨🇷": "CR",
      "Croatia 🇭🇷": "HR",
      "Cuba 🇨🇺": "CU",
      "Cyprus 🇨🇾": "CY",
      "Czechia 🇨🇿": "CZ",
      "Denmark 🇩🇰": "DK",
      "Djibouti 🇩🇯": "DJ",
      "Dominica 🇩🇲": "DM",
      "Dominican Republic 🇩🇴": "DO",
      "Ecuador 🇪🇨": "EC",
      "Egypt 🇪🇬": "EG",
      "El Salvador 🇸🇻": "SV",
      "Equatorial Guinea 🇬🇶": "GQ",
      "Eritrea 🇪🇷": "ER",
      "Estonia 🇪🇪": "EE",
      "Eswatini 🇸🇿": "SZ",
      "Ethiopia 🇪🇹": "ET",
      "Fiji 🇫🇯": "FJ",
      "Finland 🇫🇮": "FI",
      "France 🇫🇷": "FR",
      "Gabon 🇬🇦": "GA",
      "Gambia 🇬🇲": "GM",
      "Georgia 🇬🇪": "GE",
      "Germany 🇩🇪": "DE",
      "Ghana 🇬🇭": "GH",
      "Greece 🇬🇷": "GR",
      "Grenada 🇬🇩": "GD",
      "Guatemala 🇬🇹": "GT",
      "Guinea 🇬🇳": "GN",
      "Guinea-Bissau 🇬🇼": "GW",
      "Guyana 🇬🇾": "GY",
      "Haiti 🇭🇹": "HT",
      "Honduras 🇭🇳": "HN",
      "Hungary 🇭🇺": "HU",
      "Iceland 🇮🇸": "IS",
      "India 🇮🇳": "IN",
      "Indonesia 🇮🇩": "ID",
      "Iran 🇮🇷": "IR",
      "Iraq 🇮🇶": "IQ",
      "Ireland 🇮🇪": "IE",
      "Israel 🇮🇱": "IL",
      "Italy 🇮🇹": "IT",
      "Jamaica 🇯🇲": "JM",
      "Japan 🇯🇵": "JP",
      "Jordan 🇯🇴": "JO",
      "Kazakhstan 🇰🇿": "KZ",
      "Kenya 🇰🇪": "KE",
      "Kiribati 🇰🇮": "KI",
      "Korea, North 🇰🇵": "KP",
      "Korea, South 🇰🇷": "KR",
      "Kuwait 🇰🇼": "KW",
      "Kyrgyzstan 🇰🇬": "KG",
      "Laos 🇱🇦": "LA",
      "Latvia 🇱🇻": "LV",
      "Lebanon 🇱🇧": "LB",
      "Lesotho 🇱🇸": "LS",
      "Liberia 🇱🇷": "LR",
      "Libya 🇱🇾": "LY",
      "Liechtenstein 🇱🇮": "LI",
      "Lithuania 🇱🇹": "LT",
      "Luxembourg 🇱🇺": "LU",
      "Madagascar 🇲🇬": "MG",
      "Malawi 🇲🇼": "MW",
      "Malaysia 🇲🇾": "MY",
      "Maldives 🇲🇻": "MV",
      "Mali 🇲🇱": "ML",
      "Malta 🇲🇹": "MT",
      "Marshall Islands 🇲🇭": "MH",
      "Mauritania 🇲🇷": "MR",
      "Mauritius 🇲🇺": "MU",
      "Mexico 🇲🇽": "MX",
      "Micronesia 🇫🇲": "FM",
      "Moldova 🇲🇩": "MD",
      "Monaco 🇲🇨": "MC",
      "Mongolia 🇲🇳": "MN",
      "Montenegro 🇲🇪": "ME",
      "Morocco 🇲🇦": "MA",
      "Mozambique 🇲🇿": "MZ",
      "Myanmar 🇲🇲": "MM",
      "Namibia 🇳🇦": "NA",
      "Nauru 🇳🇷": "NR",
      "Nepal 🇳🇵": "NP",
      "Netherlands 🇳🇱": "NL",
      "New Zealand 🇳🇿": "NZ",
      "Nicaragua 🇳🇮": "NI",
      "Niger 🇳🇪": "NE",
      "Nigeria 🇳🇬": "NG",
      "North Macedonia 🇲🇰": "MK",
      "Norway 🇳🇴": "NO",
      "Oman 🇴🇲": "OM",
      "Pakistan 🇵🇰": "PK",
      "Palau 🇵🇼": "PW",
      "Palestine 🇵🇸": "PS",
      "Panama 🇵🇦": "PA",
      "Papua New Guinea 🇵🇬": "PG",
      "Paraguay 🇵🇾": "PY",
      "Peru 🇵🇪": "PE",
      "Philippines 🇵🇭": "PH",
      "Poland 🇵🇱": "PL",
      "Portugal 🇵🇹": "PT",
      "Qatar 🇶🇦": "QA",
      "Romania 🇷🇴": "RO",
      "Russia 🇷🇺": "RU",
      "Rwanda 🇷🇼": "RW",
      "Saint Kitts and Nevis 🇰🇳": "KN",
      "Saint Lucia 🇱🇨": "LC",
      "Saint Vincent and the Grenadines 🇻🇨": "VC",
      "Samoa 🇼🇸": "WS",
      "San Marino 🇸🇲": "SM",
      "Sao Tome and Principe 🇸🇹": "ST",
      "Saudi Arabia 🇸🇦": "SA",
      "Senegal 🇸🇳": "SN",
      "Serbia 🇷🇸": "RS",
      "Seychelles 🇸🇨": "SC",
      "Sierra Leone 🇸🇱": "SL",
      "Singapore 🇸🇬": "SG",
      "Slovakia 🇸🇰": "SK",
      "Slovenia 🇸🇮": "SI",
      "Solomon Islands 🇸🇧": "SB",
      "Somalia 🇸🇴": "SO",
      "South Africa 🇿🇦": "ZA",
      "South Sudan 🇸🇸": "SS",
      "Spain 🇪🇸": "ES",
      "Sri Lanka 🇱🇰": "LK",
      "Sudan 🇸🇩": "SD",
      "Suriname 🇸🇷": "SR",
      "Sweden 🇸🇪": "SE",
      "Switzerland 🇨🇭": "CH",
      "Syria 🇸🇾": "SY",
      "Taiwan 🇹🇼": "TW",
      "Tajikistan 🇹🇯": "TJ",
      "Tanzania 🇹🇿": "TZ",
      "Thailand 🇹🇭": "TH",
      "Timor-Leste 🇹🇱": "TL",
      "Togo 🇹🇬": "TG",
      "Tonga 🇹🇴": "TO",
      "Trinidad and Tobago 🇹🇹": "TT",
      "Tunisia 🇹🇳": "TN",
      "Turkey 🇹🇷": "TR",
      "Turkmenistan 🇹🇲": "TM",
      "Tuvalu 🇹🇻": "TV",
      "Uganda 🇺🇬": "UG",
      "Ukraine 🇺🇦": "UA",
      "United Arab Emirates 🇦🇪": "AE",
      "United Kingdom 🇬🇧": "GB",
      "United States 🇺🇸": "US",
      "Uruguay 🇺🇾": "UY",
      "Uzbekistan 🇺🇿": "UZ",
      "Vanuatu 🇻🇺": "VU",
      "Vatican City 🇻🇦": "VA",
      "Venezuela 🇻🇪": "VE",
      "Vietnam 🇻🇳": "VN",
      "Yemen 🇾🇪": "YE",
      "Zambia 🇿🇲": "ZM",
      "Zimbabwe 🇿🇼": "ZW",
    };
    return countryMap[region] || undefined;
  };

  const regions = [
    "Afghanistan 🇦🇫",
    "Albania 🇦🇱",
    "Algeria 🇩🇿",
    "Andorra 🇦🇩",
    "Angola 🇦🇴",
    "Antigua and Barbuda 🇦🇬",
    "Argentina 🇦🇷",
    "Armenia 🇦🇲",
    "Australia 🇦🇺",
    "Austria 🇦🇹",
    "Azerbaijan 🇦🇿",
    "Bahamas 🇧🇸",
    "Bahrain 🇧🇭",
    "Bangladesh 🇧🇩",
    "Barbados 🇧🇧",
    "Belarus 🇧🇾",
    "Belgium 🇧🇪",
    "Belize 🇧🇿",
    "Benin 🇧🇯",
    "Bhutan 🇧🇹",
    "Bolivia 🇧🇴",
    "Bosnia and Herzegovina 🇧🇦",
    "Botswana 🇧🇼",
    "Brazil 🇧🇷",
    "Brunei 🇧🇳",
    "Bulgaria 🇧🇬",
    "Burkina Faso 🇧🇫",
    "Burundi 🇧🇮",
    "Cabo Verde 🇨🇻",
    "Cambodia 🇰🇭",
    "Cameroon 🇨🇲",
    "Canada 🇨🇦",
    "Central African Republic 🇨🇫",
    "Chad 🇹🇩",
    "Chile 🇨🇱",
    "China 🇨🇳",
    "Colombia 🇨🇴",
    "Comoros 🇰🇲",
    "Congo, Democratic Republic of the 🇨🇩",
    "Congo, Republic of the 🇨🇬",
    "Costa Rica 🇨🇷",
    "Croatia 🇭🇷",
    "Cuba 🇨🇺",
    "Cyprus 🇨🇾",
    "Czechia 🇨🇿",
    "Denmark 🇩🇰",
    "Djibouti �🇩🇯",
    "Dominica 🇸🇴",
    "Dominican Republic 🇩🇴",
    "Ecuador 🇪🇨",
    "Egypt 🇪🇬",
    "El Salvador 🇸🇻",
    "Equatorial Guinea 🇬🇶",
    "Eritrea 🇪🇷",
    "Estonia 🇪🇪",
    "Eswatini 🇸🇿",
    "Ethiopia 🇪🇹",
    "Fiji 🇫🇯",
    "Finland 🇫🇮",
    "France 🇫🇷",
    "Gabon 🇬🇦",
    "Gambia 🇬🇲",
    "Georgia 🇬🇪",
    "Germany 🇩🇪",
    "Ghana 🇬🇭",
    "Greece 🇬🇷",
    "Grenada 🇬🇩",
    "Guatemala 🇬🇹",
    "Guinea 🇬🇳",
    "Guinea-Bissau 🇬🇼",
    "Guyana 🇬🇾",
    "Haiti 🇭🇹",
    "Honduras 🇭🇳",
    "Hungary 🇭🇺",
    "Iceland 🇮🇸",
    "India 🇮🇳",
    "Indonesia 🇮🇩",
    "Iran 🇮🇷",
    "Iraq 🇮🇶",
    "Ireland 🇮🇪",
    "Israel 🇮🇱",
    "Italy 🇮🇹",
    "Jamaica 🇯🇲",
    "Japan 🇯🇵",
    "Jordan 🇯🇴",
    "Kazakhstan 🇰🇿",
    "Kenya 🇰🇪",
    "Kiribati 🇰🇮",
    "Korea, North 🇰🇵",
    "Korea, South 🇰🇷",
    "Kuwait 🇰🇼",
    "Kyrgyzstan 🇰🇬",
    "Laos 🇱🇦",
    "Latvia 🇱🇻",
    "Lebanon 🇱🇧",
    "Lesotho 🇱🇸",
    "Liberia 🇱🇷",
    "Libya 🇱🇾",
    "Liechtenstein 🇱🇮",
    "Lithuania 🇱🇹",
    "Luxembourg 🇱🇺",
    "Madagascar 🇲🇬",
    "Malawi 🇲🇼",
    "Malaysia 🇲🇾",
    "Maldives 🇲🇻",
    "Mali 🇲🇱",
    "Malta 🇲🇹",
    "Marshall Islands 🇲🇭",
    "Mauritania 🇲🇷",
    "Mauritius 🇲🇺",
    "Mexico 🇲🇽",
    "Micronesia 🇫🇲",
    "Moldova 🇲🇩",
    "Monaco 🇲🇨",
    "Mongolia 🇲🇳",
    "Montenegro 🇲🇪",
    "Morocco 🇲🇦",
    "Mozambique 🇲🇿",
    "Myanmar 🇲🇲",
    "Namibia 🇳🇦",
    "Nauru 🇳🇷",
    "Nepal 🇳🇵",
    "Netherlands 🇳🇱",
    "New Zealand 🇳🇿",
    "Nicaragua 🇳🇮",
    "Niger 🇳🇪",
    "Nigeria 🇳🇬",
    "North Macedonia 🇲🇰",
    "Norway 🇳🇴",
    "Oman 🇴🇲",
    "Pakistan 🇵🇰",
    "Palau 🇵🇼",
    "Palestine 🇵🇸",
    "Panama 🇵🇦",
    "Papua New Guinea 🇵🇬",
    "Paraguay 🇵🇾",
    "Peru 🇵🇪",
    "Philippines 🇵🇭",
    "Poland 🇵🇱",
    "Portugal 🇵🇹",
    "Qatar 🇶🇦",
    "Romania 🇷🇴",
    "Russia 🇷🇺",
    "Rwanda 🇷🇼",
    "Saint Kitts and Nevis 🇰🇳",
    "Saint Lucia 🇱🇨",
    "Saint Vincent and the Grenadines 🇻🇨",
    "Samoa 🇼🇸",
    "San Marino 🇸🇲",
    "Sao Tome and Principe 🇸🇹",
    "Saudi Arabia 🇸🇦",
    "Senegal 🇸🇳",
    "Serbia 🇷🇸",
    "Seychelles 🇸🇨",
    "Sierra Leone 🇸🇱",
    "Singapore 🇸🇬",
    "Slovakia 🇸🇰",
    "Slovenia 🇸🇮",
    "Solomon Islands 🇸🇧",
    "Somalia 🇸🇴",
    "South Africa 🇿🇦",
    "South Sudan 🇸🇸",
    "Spain 🇪🇸",
    "Sri Lanka 🇱🇰",
    "Sudan 🇸🇩",
    "Suriname 🇸🇷",
    "Sweden 🇸🇪",
    "Switzerland 🇨🇭",
    "Syria 🇸🇾",
    "Taiwan 🇹🇼",
    "Tajikistan 🇹🇯",
    "Tanzania 🇹🇿",
    "Thailand 🇹🇭",
    "Timor-Leste 🇹🇱",
    "Togo 🇹🇬",
    "Tonga 🇹🇴",
    "Trinidad and Tobago 🇹🇹",
    "Tunisia 🇹🇳",
    "Turkey 🇹🇷",
    "Turkmenistan 🇹🇲",
    "Tuvalu 🇹🇻",
    "Uganda 🇺🇬",
    "Ukraine 🇺🇦",
    "United Arab Emirates 🇦🇪",
    "United Kingdom 🇬🇧",
    "United States 🇺🇸",
    "Uruguay 🇺🇾",
    "Uzbekistan 🇺🇿",
    "Vanuatu 🇻🇺",
    "Vatican City 🇻🇦",
    "Venezuela 🇻🇪",
    "Vietnam 🇻🇳",
    "Yemen 🇾🇪",
    "Zambia 🇿🇲",
    "Zimbabwe 🇿🇼",
  ];

  const professions = [
    "Web Development",
    "App Development",
    "Digital Marketing",
    "Lead Generation",
    "Meta Marketing",
    "Media Buying",
    "Sales & Marketing",
    "Business Development",
    "Project Management",
    "E-Commerce",
    "Python Development",
    "Social Media Management",
    "Social Media Ads",
    "SEO",
    "Email Marketing",
    "Copywriting",
    "Content Writing",
    "Taxation",
    "UI/UX Design",
    "Graphics Designing",
    "Software Development",
    "Videography",
    "Branding",
    "Academic Writing",
    "Business Management",
    "E-books",
    "White Papers",
    "Data Science",
    "AI",
    "YouTube Automation",
  ];

  const predefinedSkills = [
    "JavaScript",
    "React.js",
    "Node.js",
    "Python",
    "Java",
    "UI/UX Design",
    "SEO Optimization",
    "Content Creation",
    "Cybersecurity Analysis",
    "Cloud Architecture",
    "Database Management",
    "Mobile App Development",
    "Graphic Design",
    "Machine Learning",
    "Digital Advertising",
  ];

  const isValidUrl = (url) => {
    if (!url) return true;
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" && name === "applyForInterview") {
      setFormData({ ...formData, applyForInterview: checked });
    } else if (name in formData.socialLinks) {
      const isValid = isValidUrl(value);
      setFormData({
        ...formData,
        socialLinks: { ...formData.socialLinks, [name]: value },
      });
      setErrors((prev) => ({
        ...prev,
        [name]: isValid ? "" : `${name} link is invalid.`,
      }));
    } else if (name in formData.contact) {
      setFormData({
        ...formData,
        contact: { ...formData.contact, [name]: value },
      });
      if (name === "phone") validatePhone(value);
      if (name === "email") validateEmail(value);
    } else if (name === "portfolio") {
      const isValid = isValidUrl(value);
      setFormData({ ...formData, portfolio: value });
      setErrors((prev) => ({
        ...prev,
        portfolio: isValid ? "" : "Portfolio URL is invalid.",
      }));
    } else if (name === "password") {
      setFormData({ ...formData, password: value });
      validatePassword(value);
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validatePhone = (phone) => {
    if (!phone.trim()) {
      setErrors((prev) => ({ ...prev, phone: "Phone number is required" }));
      return false;
    }
    const countryCode = formData.region
      ? getCountryCodeFromRegion(formData.region)
      : undefined;
    const isValid = isValidPhoneNumber(phone, countryCode);
    if (!isValid) {
      setErrors((prev) => ({
        ...prev,
        phone: "Please enter a valid phone number",
      }));
      return false;
    }
    setErrors((prev) => ({ ...prev, phone: "" }));
    return true;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      setErrors((prev) => ({ ...prev, email: "Email is required" }));
      return false;
    }
    if (!emailRegex.test(email)) {
      setErrors((prev) => ({
        ...prev,
        email: "Please enter a valid email address",
      }));
      return false;
    }
    setErrors((prev) => ({ ...prev, email: "" }));
    return true;
  };

  const validatePassword = (password) => {
    if (!password.trim()) {
      setErrors((prev) => ({ ...prev, password: "Password is required" }));
      return false;
    }
    if (password.length < 6) {
      setErrors((prev) => ({
        ...prev,
        password: "Password must be at least 6 characters long",
      }));
      return false;
    }
    setErrors((prev) => ({ ...prev, password: "" }));
    return true;
  };

  const handleSkillChange = (e) => {
    const skill = e.target.value;
    if (skill && !formData.skills.includes(skill)) {
      setFormData({ ...formData, skills: [...formData.skills, skill] });
    }
  };

  const handleCustomSkillChange = (e) => {
    setCustomSkill(e.target.value);
  };

  const addCustomSkill = () => {
    if (customSkill.trim() && !formData.skills.includes(customSkill.trim())) {
      setFormData({
        ...formData,
        skills: [...formData.skills, customSkill.trim()],
      });
      setCustomSkill("");
    } else if (formData.skills.includes(customSkill.trim())) {
      toast.error("Skill already added");
    }
  };

  const removeSkill = (skillToRemove) => {
    setFormData({
      ...formData,
      skills: formData.skills.filter((skill) => skill !== skillToRemove),
    });
  };

  const handleRegionSelect = (region) => {
    setFormData({ ...formData, region });
    setSearchTerm("");
    setIsDropdownOpen(false);
  };

  const filteredRegions = regions.filter((region) =>
    region.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.skills.length === 0) {
      toast.error("Please add at least one skill");
      return;
    }

    const newErrors = {};
    let hasUrlError = false;
    Object.entries(formData.socialLinks).forEach(([key, value]) => {
      if (!isValidUrl(value)) {
        newErrors[key] = `${key} link is invalid.`;
        hasUrlError = true;
      }
    });
    if (!isValidUrl(formData.portfolio)) {
      newErrors.portfolio = "Portfolio URL is invalid.";
      hasUrlError = true;
    }
    if (hasUrlError) {
      setErrors((prev) => ({ ...prev, ...newErrors }));
      return;
    }

    const isEmailValid = validateEmail(formData.contact.email);
    const isPhoneValid = validatePhone(formData.contact.phone);
    const isPasswordValid = validatePassword(formData.password);

    if (!isEmailValid || !isPhoneValid || !isPasswordValid) {
      toast.error("Please correct invalid fields");
      return;
    }

    const socialValid = Object.values(formData.socialLinks).every(isValidUrl);
    const portfolioValid = isValidUrl(formData.portfolio);
    if (!socialValid || !portfolioValid) {
      toast.error("Please correct invalid URLs in social links or portfolio");
      return;
    }

    setIsSubmitting(true);
    try {
      // Create user in Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.contact.email,
        formData.password
      );
      const user = userCredential.user;

      // Upload picture to Cloudinary
      const pictureUrl = await uploadFileToCloudinary(formData.picture);

      // Add form data to Firestore with 'pending' status
      const freelancerData = {
        uid: user.uid,
        name: formData.name,
        expertise: formData.expertise,
        region: formData.region,
        about: formData.about,
        portfolio: formData.portfolio,
        socialLinks: formData.socialLinks,
        pictureUrl: pictureUrl,
        contact: {
          phone: formData.contact.phone,
          email: formData.contact.email,
        },
        skills: formData.skills,
        status: "pending",
        applyForInterview: formData.applyForInterview,
      };

      await addDoc(collection(db, "freelancer"), freelancerData);

      // Store user data in localStorage
      const storedUserData = {
        uid: user.uid,
        name: formData.name,
        email: formData.contact.email,
        contact: formData.contact.phone,
        role: "freelancer",
      };
      localStorage.setItem("user", JSON.stringify(storedUserData));

      toast.success(
        "Your information has been submitted. You will receive a confirmation email within 42 hours."
      );

      // Reset form
      setFormData({
        name: "",
        expertise: "",
        region: "",
        about: "",
        portfolio: "",
        socialLinks: {
          linkedin: "",
          fiverr: "",
          // twitter: "",
          facebook: "",
          upwork: "",
        },
        contact: {
          phone: "",
          email: "",
        },
        picture: null,
        skills: [],
        applyForInterview: false,
        password: "",
      });
      setCustomSkill("");
      navigate("/freelancer-dashboard");
    } catch (error) {
      console.error("Error during submission:", error);
      if (error.code === "auth/email-already-in-use") {
        toast.error(
          "Email is already registered. Please use a different email."
        );
      } else if (error.code === "auth/invalid-email") {
        toast.error("Invalid email address.");
      } else {
        toast.error(`Error uploading data: ${error.message}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <div className="max-w-4xl md:mx-auto mx-3 p-6 md:my-12 md:mb-12 mb-32 my-3 bg-white shadow-lg rounded-lg">
        <div className="md:mb-6 mb-3">
          <h2 className="text-2xl font-semibold text-gray-800">
            Submit Your Information (As a Freelancer)
          </h2>
          <div className="border-t-4 border-orange-500 mt-2 w-10 rounded-full"></div>
        </div>
        <div className="flex items-center gap-2 mb-8 text-center">
          <p className="text-gray-700 text-sm">Already have an account?</p>
          <Link
            to="/freelancer-login"
            className="text-sm font-semibold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent hover:from-orange-600 hover:to-red-600 transition-all duration-300"
          >
            Login as Freelancer
          </Link>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name */}
          <div>
            <label className="block text-gray-600 font-medium">Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              required
            />
          </div>
          {/* Contact Information */}
          <div>
            <label className="block text-gray-600 font-medium">
              Contact Information (Private):
            </label>
            <div className="space-y-2">
              <div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.contact.phone}
                  onChange={handleChange}
                  placeholder="Phone Number (e.g., +1234567890)"
                  className={`w-full p-3 border ${
                    errors.phone ? "border-red-500" : "border-gray-300"
                  } rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500`}
                  required
                />
                {errors.phone && (
                  <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
                )}
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.contact.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className={`w-full p-3 border ${
                    errors.email ? "border-red-500" : "border-gray-300"
                  } rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500`}
                  required
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>
              <div className="relative">
                {/* <label className="block text-gray-600 font-medium">
                  Password:
                </label> */}
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  placeholder="Password (minimum 6 characters)"
                  onChange={handleChange}
                  className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  required
                />
                <div
                  className="absolute top-4 right-3 cursor-pointer text-gray-500"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </div>
                {errors.password && (
                  <p className="text-red-500 text-sm mt-1">{errors.password}</p>
                )}
              </div>
            </div>
          </div>
          {/* Profession Dropdown */}
          <div>
            <label className="block text-gray-600 font-medium">
              Expertise/Profession:
            </label>
            <div className="relative">
              <div
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 flex justify-between items-center cursor-pointer"
                onClick={() => setIsDropdownProfessionOpen((prev) => !prev)}
              >
                <span>{formData.expertise || "Select Profession"}</span>
                <svg
                  className={`w-5 h-5 transform transition-transform ${
                    isDropdownProfessionOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
              {isDropdownProfessionOpen && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                  <input
                    type="text"
                    placeholder="Search professions..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none"
                  />
                  {professions
                    .filter((p) =>
                      p.toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .map((p, i) => (
                      <div
                        key={i}
                        className="px-4 py-2 hover:bg-orange-100 cursor-pointer"
                        onClick={() => {
                          setFormData({ ...formData, expertise: p });
                          setIsDropdownProfessionOpen(false);
                          setSearchTerm("");
                        }}
                      >
                        {p}
                      </div>
                    ))}
                  {professions.filter((p) =>
                    p.toLowerCase().includes(searchTerm.toLowerCase())
                  ).length === 0 && (
                    <div className="px-4 py-2 text-gray-500">
                      No matches found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* Region Dropdown */}
          <div>
            <label className="block text-gray-600 font-medium">
              Region/Area/Country:
            </label>
            <div className="relative" ref={dropdownRef}>
              <div
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 flex justify-between items-center cursor-pointer"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                <span>{formData.region || "Select Region"}</span>
                <svg
                  className={`w-5 h-5 transform transition-transform ${
                    isDropdownOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
              {isDropdownOpen && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-96 overflow-y-auto">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search countries..."
                    className="w-full p-3 border-b border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                  {filteredRegions.length > 0 ? (
                    filteredRegions.map((region, index) => (
                      <div
                        key={index}
                        className="px-4 py-2 hover:bg-orange-100 cursor-pointer transition-colors"
                        onClick={() => handleRegionSelect(region)}
                      >
                        {region}
                      </div>
                    ))
                  ) : (
                    <div className="px-4 py-2 text-gray-500">
                      No countries found
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* Skills Section */}
          <div>
            <label className="block text-gray-600 font-medium">Skills:</label>
            <div className="flex flex-col gap-2">
              <select
                name="skills"
                onChange={handleSkillChange}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              >
                <option value="">Select a Skill</option>
                {predefinedSkills.map((skill, index) => (
                  <option key={index} value={skill}>
                    {skill}
                  </option>
                ))}
              </select>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={customSkill}
                  onChange={handleCustomSkillChange}
                  placeholder="Add custom skill"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                />
                <button
                  type="button"
                  onClick={addCustomSkill}
                  className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition-all"
                  disabled={!customSkill.trim()}
                >
                  Add
                </button>
              </div>
              <div className="flex flex-wrap gap-2 mt-2">
                {formData.skills.length > 0 ? (
                  formData.skills.map((skill, index) => (
                    <div
                      key={index}
                      className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center gap-2"
                    >
                      {skill}
                      <button
                        type="button"
                        onClick={() => removeSkill(skill)}
                        className="text-white hover:text-gray-200"
                      >
                        &times;
                      </button>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500 text-sm">No skills added yet.</p>
                )}
              </div>
            </div>
          </div>
          {/* About */}
          <div>
            <label className="block text-gray-600 font-medium">
              About Me (4-5 lines):
            </label>
            <textarea
              name="about"
              value={formData.about}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              rows="5"
              required
            />
          </div>
          {/* Portfolio */}
          <div>
            <label className="block text-gray-600 font-medium">
              Portfolio/Work Sample Link:
            </label>
            <input
              type="text"
              name="portfolio"
              value={formData.portfolio}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
            {errors.portfolio && (
              <p className="text-red-500 text-sm mt-1">{errors.portfolio}</p>
            )}
          </div>
          {/* Social Links */}
          <div>
            <label className="block text-gray-600 font-medium">
              Social Links:
            </label>
            <div className="space-y-2">
              {["linkedin", "fiverr", "facebook", "upwork"].map((platform) => (
                <div key={platform}>
                  <input
                    type="text"
                    name={platform}
                    placeholder={
                      platform.charAt(0).toUpperCase() + platform.slice(1)
                    }
                    value={formData.socialLinks[platform]}
                    onChange={handleChange}
                    className={`w-full p-3 border ${
                      errors[platform] ? "border-red-500" : "border-gray-300"
                    } rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500`}
                  />
                  {errors[platform] && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors[platform]}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
          {/* Professional Picture */}
          <div>
            <label className="block text-gray-600 font-medium">
              Professional Picture:
            </label>
            <input
              type="file"
              name="picture"
              onChange={handleFileChange}
              className="w-full p-3 border border-gray-300 rounded-lg file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-orange-500 file:text-white file:hover:bg-orange-600"
              required
            />
          </div>
          <div>
            <label className="block text-gray-600 font-medium">
              <input
                type="checkbox"
                name="applyForInterview"
                checked={formData.applyForInterview}
                onChange={handleChange}
                className="mr-2"
              />
              Apply for an Interview to Get Featured
            </label>
          </div>
          {/* Submit Button */}
          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full py-3 px-6 font-semibold shadow-lg rounded-lg ${
              isSubmitting
                ? "bg-gray-500 cursor-not-allowed"
                : "bg-gradient-to-r from-orange-500 to-red-500 text-white hover:from-orange-600 hover:to-red-600"
            } transition-all`}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
      <ToastContainer />
      <Footer />
    </>
  );
};

export default UserForm;
